import React from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {useIntl} from "react-intl";
import {ProductEditValues} from "@/data/entities/menuEditor";
import {label} from "@/utils/LabelUtils";
import MultiSelectCombobox, {MultiSelectOption} from "@widgets/input/combobox/MultiSelectCombobox";

type Fulfillment = "delivery" | "takeaway";

type Props = {
    disabled: boolean,
};

/**
 * Whether the product can be ordered for delivery and/or takeaway.
 */
const AvailabilityField = ({disabled}: Props) => {
    const intl = useIntl();
    const {control, setValue} = useFormContext<ProductEditValues>();
    const [delivery, takeaway] = useWatch({control, name: ["delivery", "takeaway"]});
    const options: MultiSelectOption<Fulfillment>[] = [
        {value: "delivery", displayValue: intl.formatMessage({id: "delivery"})},
        {value: "takeaway", displayValue: intl.formatMessage({id: "takeaway"})},
    ];

    return (
        <MultiSelectCombobox<Fulfillment>
            label={label("availability", false)}
            tip={!delivery && !takeaway ? intl.formatMessage({id: "productNotOrderable"}) : undefined}
            options={options}
            value={[
                ...(delivery ? ["delivery" as const] : []),
                ...(takeaway ? ["takeaway" as const] : []),
            ]}
            onChange={(value: Fulfillment[]) => {
                setValue("delivery", value.includes("delivery"), {shouldDirty: true});
                setValue("takeaway", value.includes("takeaway"), {shouldDirty: true});
            }}
            disabled={disabled}
        />
    );
};

export default AvailabilityField;